import { render, staticRenderFns } from "./arviointilomake-aloituskeskustelu.vue?vue&type=template&id=d6ac71da&"
import script from "./arviointilomake-aloituskeskustelu.vue?vue&type=script&lang=ts&"
export * from "./arviointilomake-aloituskeskustelu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports